import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

const modalRoot =
  document.querySelector('#modal-root') || document.createElement('div')

modalRoot.id = 'modal-root'
document.body.appendChild(modalRoot)

const ModalPortal: React.FC = ({ children }) => {
  const el = useRef(document.createElement('div'))

  useEffect(() => {
    const current = el.current

    modalRoot.innerHTML = ''
    modalRoot.appendChild(current)

    return () => {
      modalRoot.innerHTML = ''
    }
  }, [])

  return createPortal(children, el.current)
}

export default ModalPortal
